import {
  PrimarySubmitButton,
  TextBlock,
  TextBlockDirection,
  TextBlockRowGap,
  TextBoxCaption3,
  TextBoxHeadline3,
} from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { translations } from '../model'

LockedBlock.displayName = 'LockedBlock'
export function LockedBlock(): JSX.Element {
  const { title, message, text, buttonText } = useUnit(
    translations.$waitingEmailConfirmationTranslations
  )

  return (
    <>
      <TextBoxHeadline3 title={title} />
      <TextBlock
        direction={TextBlockDirection.COLUMN}
        rowGap={TextBlockRowGap.INDENT_50}
      >
        <TextBoxCaption3 title={message} />
        <TextBoxCaption3 title={text} />
        <PrimarySubmitButton isLoading title={buttonText} />
      </TextBlock>
    </>
  )
}
